import React, { useState, useEffect } from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
// import banner_video from "../../Assets/banner_video.mp4";
import floatGlassImg from "../../Assets/float_glass.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import automotiveGlassImg from "../../Assets/automotive_glass.webp";
import architecturalGlassImg from "../../Assets/architectural_glass.webp";
import customerImg from "../../Assets/customer-satisfaction1.webp";
import integrityImg from "../../Assets/download.jpg";
import transparencyImg from "../../Assets/Corporate-Transparency-cover.jpg";
import productArrow from "../../Assets/product_arrow.webp";
// import productBackground from "../../Assets/home-product.webp";
// import productBackground from "../../Assets/product-home.webp";
import newbackground from "../../Assets/new_beckground.webp";
// import xinyi_glass1 from "../../Assets/xinyi_glass.webp";
// import xinyi_glass2 from "../../Assets/xinyi_glass.webp";
import user from "../../Assets/AboutUs_Img/user.png";
// import HistorybgImage from "../../Assets/image/contact.webp";
import OwlCarousel from "react-owl-carousel";
import client1 from "../../Assets/image/client1.jpeg";
import client2 from "../../Assets/image/client2.jpeg";
import client3 from "../../Assets/image/client3.jpeg";
import client4 from "../../Assets/image/client4.jpeg";
import client5 from "../../Assets/image/client5.jpeg";
// import client6 from "../../Assets/image/client6.jpeg";
import client7 from "../../Assets/image/client7.jpeg";
// import client8 from "../../Assets/image/client8.jpeg";
// import client9 from "../../Assets/image/client9.jpeg";
import client10 from "../../Assets/image/client10.png";
import client11 from "../../Assets/image/client11.jpeg";
import client12 from "../../Assets/image/client12.jpeg";
import client13 from "../../Assets/image/client13.jpeg";
import client14 from "../../Assets/image/client14.jpeg";
import client15 from "../../Assets/image/client15.png";
// import client16 from "../../Assets/image/client16.png";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import api, { PUBLIC_BASE_URL } from "../../api/api";

import NProgress from "nprogress";
import "nprogress/nprogress.css";

import AOS from "aos";
import "aos/dist/aos.css";

const Home = () => {
  const [activeTab, setActiveTab] = useState("window");
  const clientLogos = [
    client1,
    client2,
    client3,
    client4,
    client5,
    //   client6,
    client7,
    //   client8,
    //   client9,
    client10,
    client11,
    client12,
    client13,
    client14,
    client15,
    // client16,
  ];
  const historyData = [
    {
      year: 2015,
      text: "Incorporated as 'Khodiyar Industries' in Mehsana, Gujarat, with a focus on manufacturing automobile glass under the brand Khodiyar India.",
    },
    {
      year: 2021,
      text: "Company registered as 'Khodiyar Automotive Glass Private Limited' with a CIN number U26990GJ2021PTC124901.",
    },
    {
      year: 2022,
      text: "GST registration completed with GST No. 24AAICK9569R1ZF, expanding compliance and operations.",
    },
    {
      year: 2023,
      text: "Introduced new product categories including E Rickshaw Wind Shields and Insulated Windows Glass.",
    },
    {
      year: 2024,
      text: "Recognized as a Verified Plus Supplier with a growing client base and 3.8/5 rating on IndiaMART.",
    },
    {
      year: 2025,
      text: "Expanded production capabilities and focused on enhancing product quality and client satisfaction.",
    },
    {
      year: 2026,
      text: "Achieved significant business growth through expanded production capacity,customer reach and customer satisfaction in the automotive glass industry.",
    },
  ];

  useEffect(() => {
    AOS.init({ duration: 500 });
  }, []);

  const renderTabContent = () => {
    switch (activeTab) {
      case "window":
        return (
          <div id="home-txt">
            <p className="txt-head">Window Glass</p>
            <p className="product_content">
              At Khodiyar Automotive Glass Pvt. Ltd., we specialize in
              manufacturing high-quality Side Window Glasses designed for buses
              and cars, offering both functionality and a sleek aesthetic.
              Crafted using premium-grade transparent glass with a glossy
              finish, these windows are ideal for urban transportation and
              commercial automotive use.
            </p>
            <Link to="">
              <img src={productArrow} alt="arrow" />
            </Link>
            <h4>01</h4>
          </div>
        );
      case "car":
        return (
          <div id="blog-txt">
            <p className="txt-head">Car Glass</p>
            <p className="product_content">
              Upgrade safety and visibility with our high-performance Car
              Laminate Windshield Glass, specially designed for modern
              automobiles. Manufactured with premium-quality laminated glass,
              these windshields offer superior strength, clarity, and protection
              — making them a reliable choice for a wide range of vehicles.
            </p>
            <Link to="">
              <img src={productArrow} alt="arrow" />
            </Link>
            <h4>02</h4>
          </div>
        );
      case "auto":
        return (
          <div id="code-txt">
            <p className="txt-head">Automotive Glass</p>
            <p className="product_content">
              At Khodiyar Automotive Glass Pvt. Ltd., we offer a premium
              selection of Automotive Glass engineered to meet the highest
              standards of durability, clarity, and safety. Our automotive glass
              solutions are crafted using top-grade materials and modern
              manufacturing techniques, ensuring long-lasting performance across
              a wide range of vehicles.
            </p>
            <Link to="">
              <img src={productArrow} alt="arrow" />
            </Link>
            <h4>03</h4>
          </div>
        );
      case "toughened":
        return (
          <div id="toughened-txt">
            <p className="txt-head">Automotive Toughened Glass</p>
            <p className="product_content">
              Our Automotive Toughened Glass is specially manufactured for
              superior strength, durability, and safety. Processed through
              advanced thermal treatment, this glass is highly resistant to
              impact, heat, and sudden temperature changes. Widely used in
              vehicle side windows and rear windows, it ensures enhanced
              protection and long-lasting performance while maintaining
              excellent visibility and clarity.
            </p>
            <Link to="">
              <img src={productArrow} alt="arrow" />
            </Link>
            <h4>04</h4>
          </div>
        );
      case "laminated":
        return (
          <div id="laminated-txt">
            <p className="txt-head">Automotive Laminated Glass</p>
            <p className="product_content">
              Our Automotive Laminated Glass offers high safety and durability
              with advanced lamination. Made of multiple glass layers with a
              strong interlayer, it resists impact effectively. Ideal for
              windshields, it enhances security, blocks UV rays, and reduces
              noise. Ensures a safer, quieter, and more comfortable ride.
            </p>
            <Link to="">
              <img src={productArrow} alt="arrow" />
            </Link>
            <h4>05</h4>
          </div>
        );
      case "DGU Glass":
        return (
          <div id="laminated-txt">
            <p className="txt-head">Double Glazed Unit Glass</p>
            <p className="product_content">
              DGU glass has two panes with a spacer, often filled with air or
              argon for insulation. It reduces heat transfer, cutting energy
              costs. Also provides strong soundproofing. Low-E coatings boost
              performance. Ideal for windows and doors.
            </p>
            <Link to="">
              <img src={productArrow} alt="arrow" />
            </Link>
            <h4>06</h4>
          </div>
        );
      default:
        return null;
    }
  };

  NProgress.configure({ showSpinner: false, trickleSpeed: 200 });
  const [loading, setLoading] = useState(true);

  const [bannerData, setBannerData] = useState(null);

  useEffect(() => {
    NProgress.start(); // Start NProgress when API call starts
    api
      .get("homebanner")
      .then((response) => {
        // console.log("Banner Response:", response.data[0]);
        setBannerData(response.data[0]);
      })
      .catch((error) => console.error("Error fetching banner data:", error))
      .finally(() => {
        NProgress.done(); // Stop NProgress when API finishes
        setLoading(false); // Also set your loading state
      });
  }, []);

  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    NProgress.start();
    api
      .get("/news")
      .then((response) => {
        // console.log("News Response:", response.data);
        setNewsData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching news data:", error);
      })
      .finally(() => {
        NProgress.done();
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <Header />

      {/* Banner */}
      <section
        className="home_banner_section"
        style={{
          position: "relative",
          overflow: "hidden",
          height: "100vh",
          objectFit: "cover",
        }}
      >
        {bannerData ? (
          bannerData.videobg ? (
            <video
              autoPlay
              muted
              loop
              playsInline
              style={{ width: "100%", height: "100vh", objectFit: "cover" }}
            >
              <source
                src={`${PUBLIC_BASE_URL}${bannerData.videobg}`}
                type="video/mp4"
              />
            </video>
          ) : (
            <img
              src={bannerData.image}
              alt="Home Banner"
              style={{ width: "100%", height: "100vh", objectFit: "cover" }}
            />
          )
        ) : (
          <p>Loading...</p>
        )}
      </section>

      {/* About Us */}
      <section className="container-fluid about_section">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="about_text text-white">
                  <div className="common_title wow fadeInUp">
                    <h2>ABOUT US</h2>
                  </div>
                  <p className="wow fadeInUp mt-4">
                    <strong>Khodiyar Automotive Glass Pvt. Ltd.,</strong>{" "}
                    established in 2015 in Mehsana, Gujarat, is a leading
                    manufacturer of premium automotive and commercial vehicle
                    glass under the brand <strong>Khodiyar India</strong>. We
                    specialize in toughened and laminated glass, delivering high
                    quality, durability, and safety.
                  </p>
                  <p className="wow fadeInUp">
                    Backed by a modern facility and an experienced team, we
                    ensure precision, performance, and timely delivery—making us
                    a trusted name in the industry.
                  </p>

                  <div className="billion_box mt-5">
                    <div className="box wow fadeInUp">
                      <h5>2015</h5>
                      <p>Established</p>
                    </div>
                    <div className="box wow fadeInUp">
                      <h5>Khodiyar India</h5>
                      <p>Our Brand</p>
                    </div>
                    <div className="box wow fadeInUp">
                      <h5>25+</h5>
                      <p>Team Members</p>
                    </div>
                  </div>

                  <div className="common_button wow fadeInUp mt-4">
                    <Link to="/AboutUs" className="btn btn-readmore">
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="services_section">
        {" "}
        <div className="container">
          {" "}
          <div className="common_title text-center mb-5">
            {" "}
            <h2>Our Services</h2>{" "}
            <p className="service_subtitle">
              {" "}
              Delivering premium automotive glass solutions with quality and
              reliability.{" "}
            </p>{" "}
          </div>{" "}
          <div className="row">
            {" "}
            {/* Service 1 */}{" "}
            <div className="col-lg-4 col-md-6 mb-4">
              {" "}
              <div className="service_card">
                {" "}
                <div className="service_img">
                  {" "}
                  <img src={customerImg} alt="Window Glass" />{" "}
                </div>{" "}
                <div className="service_content">
                  {" "}
                  <h4>Customer Satisfaction</h4>{" "}
                  <p>
                    {" "}
                    We prioritize customer needs by delivering reliable
                    automotive glass solutions with exceptional quality, timely
                    service, and long-lasting performance.{" "}
                  </p>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
            {/* Service 2 */}{" "}
            <div className="col-lg-4 col-md-6 mb-4">
              {" "}
              <div className="service_card">
                {" "}
                <div className="service_img">
                  {" "}
                  <img src={integrityImg} alt="Car Glass" />{" "}
                </div>{" "}
                <div className="service_content">
                  {" "}
                  <h4>Integrity</h4>{" "}
                  <p>
                    {" "}
                    We maintain the highest standards of honesty, quality, and
                    professionalism in every automotive glass product we
                    manufacture.{" "}
                  </p>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
            {/* Service 3 */}{" "}
            <div className="col-lg-4 col-md-6 mb-4">
              {" "}
              <div className="service_card">
                {" "}
                <div className="service_img">
                  {" "}
                  <img src={transparencyImg} alt="Automotive Glass" />{" "}
                </div>{" "}
                <div className="service_content">
                  {" "}
                  <h4>Transparency</h4>{" "}
                  <p>
                    {" "}
                    We believe in clear communication, trusted business
                    practices, and delivering products with complete reliability
                    and clarity.{" "}
                  </p>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </section>
      {/* Product Section */}
      <section
        className="container-fluid product_section"
        // style={{ backgroundImage: `url(${productBackground})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 product_first_col">
              <div id="text">{renderTabContent()}</div>
            </div>
            <div
              className="col-lg-6 col-md-6 col-sm-12 product_sec_col"
              style={{ backgroundColor: "#000" }}
            >
              <div className="common_title">
                <h2>Products</h2>
              </div>
              <div id="tabs">
                <div
                  onClick={() => setActiveTab("window")}
                  className={`tabbing_img ${activeTab === "window" ? "active" : ""}`}
                >
                  <img src={floatGlassImg} alt="Window Glass" /> Window Glass
                </div>

                <div
                  onClick={() => setActiveTab("car")}
                  className="tabbing_img"
                  style={{ cursor: "pointer" }}
                >
                  <img src={automotiveGlassImg} alt="Car Glass" /> Car Glass
                </div>
                {/* <div
                  onClick={() => setActiveTab("auto")}
                  className="tabbing_img"
                  style={{ cursor: "pointer" }}
                >
                  <img src={architecturalGlassImg} alt="Automotive Glass" />{" "}
                  Automotive Glass
                </div> */}
                <div
                  onClick={() => setActiveTab("toughened")}
                  className="tabbing_img"
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={architecturalGlassImg}
                    alt="Automotive Toughened Glass"
                  />
                  Automotive Toughened Glass
                </div>
                <div
                  onClick={() => setActiveTab("laminated")}
                  className="tabbing_img"
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={architecturalGlassImg}
                    alt="Automotive Laminated Glass"
                  />{" "}
                  Automotive Laminated Glass
                </div>
                <div
                  onClick={() => setActiveTab("DGU Glass")}
                  className="tabbing_img"
                  style={{ cursor: "pointer" }}
                >
                  <img src={automotiveGlassImg} alt="Car Glass" /> DGU Glass
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* News Section */}
      <section
        className="container-fluid new_section "
        style={{
          backgroundImage: `url(${newbackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="row mt-5 mb-5">
          <div className="col-lg-3 col-md-12">
            <div className="common_title wow fadeInUp">
              <h2>News</h2>
            </div>
            <div className="new_left_text">
              <Link to="">Company News</Link>
              <Link to="">/Social Welfare</Link>
              <Link to="">/Video Center</Link>
            </div>
            <div className="common_button wow fadeInUp">
              <Link to="/AboutUs" className="btn">
                Learn More
              </Link>
            </div>
          </div>
          <div className="col-lg-9 col-md-12">
            <div className="new_right_box">
              {loading ? (
                <p>Loading...</p> // Display a loading message or spinner while the data is being fetched
              ) : (
                newsData.map((item, idx) => (
                  <div className="news-card" key={idx}>
                    <div className="big-date">
                      {new Date(item.publish_date).getDate()}
                    </div>
                    <div className="small-date">
                      {new Date(item.publish_date).toLocaleString("default", {
                        month: "numeric",
                        year: "numeric",
                      })}
                    </div>
                    <h3 className="title">{item.title}</h3>
                    <img
                      src={`${PUBLIC_BASE_URL}/images/${item.image}`}
                      alt="News"
                      className="news-img"
                    />
                    <p className="description">{item.description}</p>
                    {/* <Link to="" className="details-link">
                      Details
                    </Link> */}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Our Clients Section */}
      <section className="clients_section">
        <div className="container">
          <div className="clients_heading">
            <h2>Our Certifications</h2>
          </div>

          <Swiper
            modules={[Autoplay, Navigation]}
            slidesPerView={6}
            spaceBetween={20}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            navigation
            breakpoints={{
              320: {
                slidesPerView: 2,
              },
              576: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 4,
              },
              992: {
                slidesPerView: 5,
              },
              1200: {
                slidesPerView: 6,
              },
            }}
            className="client_swiper"
          >
            {clientLogos.map((logo, index) => (
              <SwiperSlide key={index}>
                <div className="client_logo_box">
                  <img src={logo} alt={`Client ${index + 1}`} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="ags_section ags_why">
        <div className="ags_inner">
          <div className="ags_section_label">Why KHODIYAR GLASS</div>

          <h2 className="ags_section_title">
            Why Choose <span>Khodiyar Glass</span>
          </h2>

          <p className="ags_section_desc">
            Established in 2015 in Mehsana, Gujarat, Khodiyar Industries is a
            trusted manufacturer of premium automotive and commercial vehicle
            glass, known for durability, precision finishing, and customized
            solutions at competitive prices.
          </p>

          <div className="ags_why_grid">
            <div className="ags_why_card">
              <div className="ags_why_ico">🏗️</div>

              <h3>Advanced Manufacturing</h3>

              <p>
                Our modern production facility is equipped with advanced
                machinery to manufacture high-quality automotive and commercial
                vehicle glass with precision and consistency.
              </p>
            </div>

            <div className="ags_why_card">
              <div className="ags_why_ico">📋</div>

              <h3>Wide Product Range</h3>

              <p>
                We offer Automobile Toughened Glass, Automotive Toughened Glass,
                Tempered Glass, and customized solutions suitable for multiple
                vehicle applications.
              </p>
            </div>

            <div className="ags_why_card">
              <div className="ags_why_ico">🔒</div>

              <h3>Premium Quality Standards</h3>

              <p>
                Every glass product is manufactured using premium-grade silicon
                and tested to ensure exceptional strength, clarity, scratch
                resistance, and durability.
              </p>
            </div>

            <div className="ags_why_card">
              <div className="ags_why_ico">🌐</div>

              <h3>Trusted Industry Presence</h3>

              <p>
                Since 2015, Khodiyar Industries has earned the trust of
                customers across India through reliable products, quality
                service, and long-term business relationships.
              </p>
            </div>

            <div className="ags_why_card">
              <div className="ags_why_ico">⚙️</div>

              <h3>Customized Glass Solutions</h3>

              <p>
                We provide customized glass solutions tailored to client
                requirements, ensuring perfect fit, performance, and
                satisfaction for every project.
              </p>
            </div>

            <div className="ags_why_card">
              <div className="ags_why_ico">🚚</div>

              <h3>Timely Delivery</h3>

              <p>
                We ensure fast and reliable delivery of automotive glass
                products with secure packaging and efficient logistics support.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <div className="container">
          {/* Section Title */}
          <div className="sec-title light">
            <div className="title">Testimonial</div>
            <h2>What Clients Say</h2>
          </div>

          {/* Owl Carousel */}
          <OwlCarousel
            className="owl-theme"
            loop
            margin={30}
            nav
            dots={false}
            autoplay
            smartSpeed={800}
            responsive={{
              0: {
                items: 1,
              },
              768: {
                items: 2,
              },
            }}
          >
            {/* Testimonial 1 */}
            <div className="item">
              <div className="testimonial-card">
                <div className="client-image">
                  <img src={user} alt="Mr. Dipesh Sethia" />
                </div>

                <div className="testimonial-content">
                  <div className="top-area">
                    <h3>Mr. Dipesh Sethia</h3>

                    <div className="rating">
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                    </div>
                  </div>

                  <p>
                    Excellent glass quality with durable finishing and
                    professional customer service.
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="item">
              <div className="testimonial-card">
                <div className="client-image">
                  <img src={user} alt="Rahul Patel" />
                </div>

                <div className="testimonial-content">
                  <div className="top-area">
                    <h3>Rahul Patel</h3>

                    <div className="rating">
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                    </div>
                  </div>

                  <p>
                    Best quality automotive glass with excellent support and
                    affordable pricing.
                  </p>
                </div>
              </div>
            </div>
            {/* Testimonial 4 */}
            <div className="item">
              <div className="testimonial-card">
                <div className="client-image">
                  <img src={user} alt="Jigarbhai Patel" />
                </div>

                <div className="testimonial-content">
                  <div className="top-area">
                    <h3>Jigarbhai Patel</h3>

                    <div className="rating">
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      {/* <span className="fa fa-star"></span> */}
                    </div>
                  </div>

                  <p>
                    Great experience working with the team. Their attention to
                    detail and commitment to quality make them highly
                    recommended.
                  </p>
                </div>
              </div>
            </div>
            {/* Testimonial 5 */}
            <div className="item">
              <div className="testimonial-card">
                <div className="client-image">
                  <img src={user} alt="Anurag dubey" />
                </div>

                <div className="testimonial-content">
                  <div className="top-area">
                    <h3>Anurag dubey</h3>

                    <div className="rating">
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      {/* <span className="fa fa-star"></span>
                <span className="fa fa-star"></span> */}
                    </div>
                  </div>

                  <p>
                    Impressed with the strength, clarity, and finish of the
                    glass products. Delivery was quick and hassle-free.
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="item">
              <div className="testimonial-card">
                <div className="client-image">
                  <img src={user} alt="Deepak malakar" />
                </div>

                <div className="testimonial-content">
                  <div className="top-area">
                    <h3>Deepak malakar</h3>

                    <div className="rating">
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      {/* <span className="fa fa-star"></span>
                <span className="fa fa-star"></span> */}
                    </div>
                  </div>

                  <p>
                    Reliable automotive glass products with premium quality and
                    timely delivery.
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 6 */}
            <div className="item">
              <div className="testimonial-card">
                <div className="client-image">
                  <img src={user} alt="Hardik patel" />
                </div>

                <div className="testimonial-content">
                  <div className="top-area">
                    <h3>Hardik patel</h3>

                    <div className="rating">
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      {/* <span className="fa fa-star"></span> */}
                    </div>
                  </div>

                  <p>
                    Professional service and excellent product quality. They
                    provided the right solution for my automotive glass needs at
                    a reasonable cost.
                  </p>
                </div>
              </div>
            </div>
          </OwlCarousel>
        </div>
      </section>
      {/* History Section */}
      {/* <section
        className="history_section"
        style={{
          backgroundImage: `url(${HistorybgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="common_title wow fadeInUp">
                <h2>History</h2>
              </div>
            </div>
          </div>
          <Swiper
            modules={[Navigation]}
            slidesPerView={1}
            navigation
            loop
            className="viedo_carousel_section"
          >
            {historyData.map((item, idx) => (
              <SwiperSlide key={idx}>
                <div className="history_box">
                  <div className="enhancing_text">
                    <h4>{item.year}</h4>
                  </div>
                  <p>{item.text}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section> */}

      <section className="history_section_v2">
        <div className="container">
          <h2 className="history_title">Our Journey</h2>
          <div className="timeline">
            {historyData.map((item, idx) => (
              <div key={idx} className="timeline_item" data-aos="fade-up">
                <div className="timeline_content">
                  <h4 className="timeline_year">{item.year}</h4>
                  <p className="timeline_text">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;

